import { RadioGroup } from '@egw/components'

import { Button, Field, ModalDrawer, useModalState } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { FC, useEffect, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { netWorthRangeItems } from '../../../constants/confirm-personal-info/confirm-personal-info'
import { PersonalNetWorthRange } from '@egw/api/src/models/enrollment/enrollment'

// Compononent to Be used within a FormProvider from react-hook-form
export const EditNetWorth: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const { openModal, closeModal, isOpen } = useModalState()

  const [defaultNetWorth, setDefaultNetWorth] = useState<PersonalNetWorthRange | undefined>(undefined)

  const { control, watch, setValue } = useFormContext()

  const netWorth = watch('netWorth')

  useEffect(() => {
    if (netWorth !== undefined && defaultNetWorth === undefined) {
      setDefaultNetWorth(netWorth)
    }
  }, [netWorth])

  // Closes the modal and reverts the value to the default value
  // Only using the closeModal method will persist the value
  const closeWithoutSaving = () => {
    setValue('netWorth', defaultNetWorth)
    closeModal()
  }

  // Sets the new default value for future edits
  const closeWithSaving = () => {
    setDefaultNetWorth(netWorth)
    closeModal()
  }

  return (
    <>
      <Field
        className="border-b py-sm"
        valueClassName="text-text-meta typo-primary-base-regular"
        value={t('edit_fields.personal_net_worth_title')}
        rightValue={t(`personal_net_worth_range.${netWorth}`)}
        testId={'editIsBrokerDealer'}
        onEdit={openModal}
        isPII
      />
      <ModalDrawer isOpen={isOpen} onClose={closeWithoutSaving} title={t('edit_fields.edit_personal_net_worth')}>
        <>
          <Controller
            name="netWorth"
            control={control}
            rules={{
              required: t('common.required_field'),
            }}
            render={({ field: { ref, ...restField } }) => (
              <RadioGroup
                {...restField}
                onChange={(e) => {
                  restField.onChange(e)
                }}
                options={netWorthRangeItems.map((item) => ({
                  value: item.value,
                  label: t(`personal_net_worth_range.${item.value}`),
                }))}
                name="personalNetWorthRange"
                className="pb-sm mt-md"
                testId="net-worth-radio"
                isPII
              />
            )}
          />
          <Button size="small" onClick={closeWithSaving} className="w-full mt-lg" testId="primaryAction_button">
            {t('common.confirm')}
          </Button>
        </>
      </ModalDrawer>
    </>
  )
}
